import { Card, Spinner } from "react-bootstrap";
import useSignFormPayload from "../form/hooks/useSignFormPayload";
import Signature from "../../../CommonComponents/Signature/Signature";

export default function PdfTemplateDisplay() {
    const { pdfUrl, handleSubmit, loadSignatures, payload, loadingSignedDocs } =
        useSignFormPayload();

    const { template_id, batch_student_id, student_id } = payload;

    // Check if we should show single student PDF
    const shouldDisplaySinglePdf = template_id && batch_student_id && pdfUrl;

    return (
        <Card className="">
            <Card.Body>
                {!template_id && <div>Please select PDF template</div>}

                {/* Single Student PDF View */}
                {shouldDisplaySinglePdf && (
                    <>
                        <div className="mb-3">
                            <h6>Individual Student PDF</h6>
                        </div>
                        <div className="pdf-viewer">
                            <embed
                                src={pdfUrl}
                                type="application/pdf"
                                width="100%"
                                height="600px"
                            />
                        </div>
                        {loadingSignedDocs ? (
                            <>
                                <Card className="mt-3">
                                    <Card.Body className="text-center">
                                        <Spinner
                                            animation="border"
                                            role="status"
                                        >
                                            <span className="visually-hidden">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    </Card.Body>
                                </Card>
                            </>
                        ) : (
                            <Signature
                                key={batch_student_id}
                                onSubmit={handleSubmit}
                                studentId={student_id}
                                loadingSignatures={loadSignatures}
                                additionalPayloadData={payload}
                            />
                        )}
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
